"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllRuleV2 = exports.getAllRuleV2Serializer = exports.allV2 = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const rule_1 = require("./rule");
const ruleHeader_1 = require("./ruleHeader");
const ruleType_1 = require("./ruleType");
const allV2 = (rules) => ({ type: 'All', rules });
exports.allV2 = allV2;
const getAllRuleV2Serializer = () => (0, ruleHeader_1.wrapSerializerInRuleHeaderV2)(ruleType_1.RuleTypeV2.All, (0, serializers_1.struct)([['rules', (0, serializers_1.array)((0, rule_1.getRuleV2Serializer)(), { size: (0, serializers_1.u64)() })]]));
exports.getAllRuleV2Serializer = getAllRuleV2Serializer;
const isAllRuleV2 = (rule) => (0, rule_1.isRuleV2)(rule) && rule.type === 'All';
exports.isAllRuleV2 = isAllRuleV2;
//# sourceMappingURL=all.js.map